export const updateFullStoryWithBrazeId = (
  brazeId: string | undefined
): void => {
  if (brazeId) {
    if (typeof (window as any).FULLSTORY !== "undefined") {
      (window as any).FULLSTORY.identify(brazeId);
    }
  }
};
